import { CraftItemType } from 'src/app/core/enums/CraftItemTypes';
import { NumberStringMap } from 'src/app/core/models/common.models';

export const CRAFT_ITEM_SMALL_ICONS: Readonly<NumberStringMap> = {
  [CraftItemType.feature]: 'item--theme-sm',
  [CraftItemType.topic]: 'item--epic-sm',
  [CraftItemType.story]: 'item--story-sm',
  [CraftItemType.requirement]: 'item--requirement-sm',
  [CraftItemType.improvement]: 'item--improvement-sm',
  [CraftItemType.task]: 'item--task-sm',
  [CraftItemType.bug]: 'item--bug-sm',
  [CraftItemType.pageStory]: 'general--image-sm',
  [CraftItemType.subtask]: 'item--subtask-sm',
};
